import { Component } from 'react';

import Animation from './animation';
import animationTypeImagePaths from 'state/static-data/animation-type-image-paths';

class Animations extends Component<any> {
  renderAnimationTypeImages(animationType) {
    return animationTypeImagePaths[animationType].map(function (
      { default: imagePath },
      index
    ) {
      return (
        <img
          alt=''
          key={index}
          className={`${animationType}-${index}`}
          src={imagePath}
        />
      );
    });
  }

  renderAnimations() {
    return this.props.animationTypes.map((animationType, index) => {
      return (
        <Animation
          key={index}
          type={animationType}
          active={this.props.activeAnimationType === animationType}
          canvas={this.props.canvas}
          started={this.props.animationStarted}
          done={this.props.animationDone}
          duration={this.props.duration}
          onComplete={this.props.onAnimationComplete}
        >
          {this.renderAnimationTypeImages(animationType)}
        </Animation>
      );
    });
  }

  render() {
    return <div className='animations'>{this.renderAnimations()}</div>;
  }
}

export default Animations;
